define([
  "marionette",
  "messaging/messenger",
  "i18n/i18n",
  "./redactSurveyCommentModalView",
  "modules/shared/surveyComments/surveyCommentsModel",
], function (Marionette, Messenger, i18next, RedactSurveyCommentModalView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "redactSurveyCommentModal";
    },
    show: function (comment) {
      this.selectionStart = -1;
      this.selectionEnd = -1;
      this.view = new RedactSurveyCommentModalView.view({ model: comment });
      this.view.on("cancel", this._onCancel, this);
      this.view.on("done", () => this._onDone(comment));
      this.view.on("select", this._onSelect, this);
      this.showRegion(this.view);
    },
    _onCancel: function () {
      Messenger.vent.trigger("close:modal");
    },
    _onDone: function (comment) {
      this._redactComment(comment).then(() => Messenger.vent.trigger("close:modal"));
    },
    _onSelect: function (selectionStart, selectionEnd) {
      if (selectionStart < 0 || selectionEnd < 0 || selectionStart === selectionEnd) {
        this.selectionStart = -1;
        this.selectionEnd = -1;
      } else {
        this.selectionStart = selectionStart;
        this.selectionEnd = selectionEnd;
      }
    },
    _redactComment: async function (comment) {
      if (this.selectionStart < 0 || this.selectionEnd < 0) {
        return;
      }
      const redactedText = i18next.t("surveyComments.redactComment.redactedPlaceholder");
      const originalCommentText = comment.get("comment");
      const updatedCommentText =
        originalCommentText.substring(0, this.selectionStart) +
        redactedText +
        originalCommentText.substring(this.selectionEnd);
      comment.set("comment", updatedCommentText);
      return Messenger.reqres.request("redact:survey:comment", {
        comment: updatedCommentText,
        time: comment.get("time") || comment.get("date"),
        touchpointId: comment.get("touchPointId") || comment.get("touchpoint"),
        localeId: comment.get("localeId"),
        rating: comment.get("rating"),
        topicId: comment.get("intentId") || comment.get("topicId"),
      });
    },
  });
});
